import { useTranslate } from "ra-core";
import { cn } from "@/lib/utils";

import { useMyPhoneExt } from "./useMyPhoneExt";

/**
 * In the profile: the user's extension, or why there is no «Позвонить».
 * `row`: label and value on one line (the phone settings).
 */
export const PhoneExtNote = ({ row = false }: { row?: boolean }) => {
  const translate = useTranslate();
  const { ext, isPending } = useMyPhoneExt();
  if (isPending) return null;
  return (
    <div
      className={cn(
        row ? "flex items-baseline justify-between gap-4" : "space-y-1",
      )}
    >
      <p
        className={cn(
          row ? "text-sm shrink-0" : "text-xs text-muted-foreground",
        )}
      >
        {translate("crm.calls.ext_label")}
      </p>
      {ext ? (
        <p className={cn("text-sm", row && "text-right")}>{ext}</p>
      ) : (
        <p
          className={cn(
            "text-sm text-muted-foreground",
            row && "text-right text-xs",
          )}
          data-testid="no-ext-hint"
        >
          {translate("crm.calls.no_ext_hint")}
        </p>
      )}
    </div>
  );
};
